import { PageHeader } from '@/components/PageHeader'
import { cn } from '@/lib/utils'
import {
  createFileRoute,
  Link,
  Outlet,
  useRouterState,
} from '@tanstack/react-router'
import { BuildingIcon, Zap } from 'lucide-react'

export const Route = createFileRoute('/_dashboard/settings')({
  component: RouteComponent,
})

const routes = [
  {
    path: '/settings/business',
    title: 'Business',
    icon: BuildingIcon,
  },
  {
    path: '/settings/integrations',
    title: 'Integrations',
    icon: Zap,
  },
]

function RouteComponent() {
  return <Outlet />
  const routeState = useRouterState({
    select: (state) => state.location.pathname,
  })
  return (
    <div className="p-8">
      {/* Header */}
      <PageHeader
        title="Settings"
        description="Manage your settings"
        className="mb-8"
      />

      <div className="flex gap-4 border-b-2 border-border">
        {routes.map((route) => {
          const isActive = routeState === route.path
          return (
            <Link
              key={route.path}
              to={route.path}
              className={cn(
                'flex items-center font-semibold gap-2 border-b-2 -mb-0.5 pb-3 px-4',
                isActive && 'border-b-2 border-primary text-primary',
                !isActive &&
                  'text-muted-foreground hover:border-primary/30 hover:text-primary/50',
              )}
            >
              {/* <route.icon className="w-4 h-4" /> */}
              {route.title}
            </Link>
          )
        })}
      </div>
      <main className="mt-8 ">
        <Outlet />
      </main>
    </div>
  )
}
